<template>
  <section class="product-intros">
    <ul class="product-list" :class="{'has-full-view': hasFullView}">
      <li
        v-for="post in products"
        :key="post.id"
        :data-id="post.id"
        :id="post|itemId"
        :class="{'contracted': post.slug !== expandedProductSlug, 'partial-view': isPartial(post), 'full-view': isFull(post)}"
      >
        <h2 @click="expandProduct(post.routerLink)">{{post.title}}</h2>
        <div class="offset" :id="post|itemIdSpan"></div>
        <product :product="post" :full="isFull(post)">
          <div class="product-overlay">{{labels.more_info_about}}</div>
        </product>
      </li>
    </ul>
  </section>
</template>
<script>
import Product from "./Product.vue";
import { mapGetters } from "vuex";
import filters from "../mixins/filters";
import { getCart } from "../api/ecwid";

export default {
  name: "ProductList",
  components: {
    Product,
  },
  mixins: [filters],
  computed: {
    ...mapGetters(["products", "labels"]),
    wrapperClasses() {
      let cls = ["wrapper"];

      return cls;
    },
    hasExpandedItem() {
      return this.expandedProductSlug.length > 2;
    },
    hasFullView() {
      return this.currProductSlug.length > 2;
    },
  },
  data() {
    return {
      expandedProductSlug: "",
      currProductSlug: "",
    };
  },
  watch: {
    "$route.path"() {
      this.matchCurrentSlug();
    },
  },
  created() {
    this.matchCurrentSlug();
  },
  methods: {
    matchCurrentSlug() {
      if (this.$route.path) {
        this.currProductSlug = this.$route.path.split("/").pop();
        this.expandedProductSlug = this.currProductSlug;
      }
    },
    expandProduct(routerLink) {
      let slug = "";
      if (typeof routerLink === "string") {
        if (routerLink.length > 1) {
          slug = routerLink.split("/").pop();
        }
      }
      if (slug !== this.expandedProductSlug) {
        this.expandedProductSlug = slug;
        this.showFullProduct(routerLink);
      } else {
        this.expandedProductSlug = "/";
        this.currProductSlug = "/";
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      }
    },
    showFullProduct(routerLink) {
      let nextLink = routerLink === this.$route.path ? "/" : routerLink;
      if (routerLink.length > 2) {
        let slug = routerLink.split("/").pop();
        if (slug !== this.currProductSlug) {
          this.currProductSlug = routerLink.split("/").pop();
          this.$router.push(nextLink);
        }
      }
    },
    isFull(post) {
      return post.slug === this.currProductSlug;
    },
    isPartial(post) {
      return (
        post.slug !== this.currProductSlug &&
        post.slug === this.expandedProductSlug
      );
    },
  },
};
</script>